<template>
    <drawer title="Create a new page" class="flex-create-page">
        <template v-slot:header-secondary>
            <drawer-tabs
                :tabs="drawerNavTabs"
                :active-tab="activeNavTab"
                @selected="setActiveTab"
            />
        </template>

        <component
            :is="pageType"
            v-if="!pageBaseSelected"
            @selected="selected"
        />

        <div v-else class="page-data__container">
            <div v-show="isSaving">
                <loading-component />
            </div>

            <template v-show="!isSaving">
                <button class="page-data__back" @click="backToSelect">
                    <font-awesome-icon :icon="['fal', 'arrow-left']" /> Back
                </button>

                <page-data @save="createPage" @cancel="hideDrawer" />
            </template>
        </div>
    </drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import LoadingComponent from '@/components/shared/loading/loading-component';
import Drawer from '@/components/shared/drawer/drawer';
import DrawerSearch from '@/components/shared/drawer/search';
import DrawerTabs from '@/components/shared/drawer/tabs';
import PageData from '@/components/page-editor/shared/page-data';
import * as service from '@/sitecore/sitecore-data-service';
import { HIDE_DRAWER, SHOW_ALERT, TRIGGER_PAGE_CREATED } from '@/store/types/mutation-types';

export default {
    components: {
        Drawer,
        LoadingComponent,
        PageData,
        DrawerSearch,
        DrawerTabs,
    },

    data() {
        return {
            isSaving: false,
            showNav: true,
            drawerNavTabs: ['Templates', 'Prototypes'],
            activeNavTab: 'Templates',
            pageBaseSelected: false,
            pageBase: {},
        };
    },

    computed: {
        ...mapState({
            newPagePath: ({ page }) => page.newPagePath,
        }),

        pageType() {
            let current;
            switch (this.activeNavTab) {
                case 'Templates': {
                    current = 'template-browser';
                    break;
                }
                case 'Prototypes': {
                    current = 'prototype-browser';
                    break;
                }
                default: {
                    current = 'template-browser';
                }
            }
            return current;
        },
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            showAlert: SHOW_ALERT,
            triggerPageCreated: TRIGGER_PAGE_CREATED,
        }),

        setActiveTab(tab) {
            this.activeNavTab = tab;
        },

        selected(pageBase) {
            this.pageBase = pageBase;
            this.pageBaseSelected = true;
            this.showNav = false;
        },

        backToSelect() {
            this.pageBaseSelected = false;
            this.showNav = true;
        },

        async createPage(pageData) {
            this.isSaving = true;
            const fullPageData = pageData;
            fullPageData.path = this.newPagePath;
            fullPageData.templateId = this.pageBase.id;
            if (this.activeNavTab === 'Prototypes') {
                fullPageData.prototypeId = this.pageBase.id;
            }
            const response = await service.createPage(fullPageData);
            if (response.status === 'error') {
                this.isSaving = false;
                this.showAlert({ description: response.error });
                return;
            }
            window.location.href = `/editor/${ response.data }`;
        },
    },
};
</script>

<style lang="scss">
.flex-create-page {
    overflow-y: auto;

    .page-data {
        &__container {
            min-width: 100%;
            height: calc(100vh - #{ $drawer-header-height } - 50px); // 50px = height of buttons on bottom
            overflow-y: auto;
        }

        &__back {
            margin: 25px 35px 0 35px;
            color: var(--form-buttonBackgroundColor);
        }
    }
}
</style>
